import { oauthProviderClient } from "@better-auth/oauth-provider/client";
import { ac, roles } from "@cva/shared/access";
import { organizationClient, twoFactorClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
  baseURL: window.location.origin,
  basePath: "/api/auth",
  plugins: [organizationClient({ ac, roles }), oauthProviderClient(), twoFactorClient()],
});

export type Session = typeof authClient.$Infer.Session;

/**
 * Better Auth answers with `{ redirect: true, url }` when a sign-in continues
 * an OAuth authorization (e.g. ChatGPT connecting to the MCP server).
 */
export function followAuthRedirect(data: unknown): boolean {
  if (data && typeof data === "object" && "redirect" in data && "url" in data) {
    const { redirect, url } = data as { redirect?: boolean; url?: string };
    if (redirect && url) {
      window.location.href = url;
      return true;
    }
  }
  return false;
}
